﻿import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { AppModalHvorLengeContainerId } from './Ids';
import { AppModalOmStudieplassContainerId } from './Ids';
import { AppModalOmPermisjonContainerId } from './Ids';
import { AppModalOmNavContainerId } from './Ids';
import { AppModalErStudentContainerId } from './Ids';
import { AppModalOmNarJegKanSokeContainerId } from './Ids';

import configureStore from './Store';
import InitEpiMessages from '../Shared/Scripts/Utilities/EpiMessages';
import { updateLanguage } from '../Shared/Scripts/Store/EpiContext/Actions';
import { epiResolveLanguage } from '../Shared/Scripts/Utilities/EpiResolveLanguage';

const store = configureStore();
store.dispatch(updateLanguage(epiResolveLanguage()));

const container = document.getElementById(AppModalHvorLengeContainerId);

if (container != null) {
    const root = createRoot(container!);
    const contentLink = container.attributes['data-content'].value as string;
    InitEpiMessages(store, contentLink);

    interface ModalOwnProps {
        modalid: string;
    }

    type ModalProps = ModalOwnProps;

    const AppRoot = (props: ModalProps): JSX.Element => (
        <Provider store={store}>
            <App modalid={props.modalid} />
        </Provider>
    );

    root.render(<AppRoot modalid={AppModalHvorLengeContainerId} />);

    function renderModal(elementId: string ){
        const modal2 = document.getElementById(elementId);
        const root2 = createRoot(modal2!);
        if(root2  != null) {
            root2.render(<AppRoot modalid={elementId} />);
        }
    }
   
    renderModal(AppModalOmStudieplassContainerId);
    renderModal(AppModalOmPermisjonContainerId);
    renderModal(AppModalOmNavContainerId);
    renderModal(AppModalErStudentContainerId);
    renderModal(AppModalOmNarJegKanSokeContainerId);
}
